import { render, staticRenderFns } from "./DeactivateNode.vue?vue&type=template&id=78d20a60&"
import script from "./DeactivateNode.vue?vue&type=script&lang=js&"
export * from "./DeactivateNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports